import React from 'react';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

import { Loading } from 'src/components/DataState';
import * as Colors from 'src/styles/colors';
import spacing from 'src/styles/spacing';
import { USERS_WITH_COUNT } from 'src/contexts/ResourcesContext';
import {
  Container,
  ColumnContainer,
  TextContainer,
  HeaderLabel,
  RedSeparator,
} from '../Headers/elements';

const ContactsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: ${spacing.sectionSpacing} ${spacing.pageGutter} 60px;
`;

const ContactRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 18px;
`;

const EmailRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

const WEB_CONTACTS_VARIABLES = {
  filterColumns: [],
  filterNames: [],
  scopes: ['web_contacts'],
};

const Contacts = () => {
  const { data, loading } = useQuery(USERS_WITH_COUNT, {
    variables: WEB_CONTACTS_VARIABLES,
  });

  const contacts = data?.usersWithCount?.entries || [];

  return (
    <>
      <Container>
        <ColumnContainer>
          <TextContainer>
            <HeaderLabel>
              Contacts
            </HeaderLabel>
            <RedSeparator />
          </TextContainer>
        </ColumnContainer>
      </Container>
      {loading ? <Loading /> :
        <ContactsSection>
          {contacts.length ?
            contacts.map(contact => (
              <ContactRow key={contact.id}>
                <div>
                  {contact.title ?
                    `${contact.fullName} - ${contact.title}` :
                    contact.fullName
                  }
                </div>
                <EmailRow>
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    size='lg'
                    style={{ color: Colors.elRed }}
                  />
                  <a
                    href={`mailto:${contact.email}`}
                    style={{ color: Colors.elRed }}
                  >
                    {contact.email}
                  </a>
                </EmailRow>
              </ContactRow>
            )) :
            <div>No contacts are available right now.</div>
          }
        </ContactsSection>
      }
    </>
  );
};

export default Contacts;
